import request from '@/utils/request'
import { formatParam } from '@/utils/tool'
import { REQ_HOTEL_DETAIL, REQ_HOTEL_ORDER, REQ_LIST, REQ_ORDER_INPUT, RES_ADINFO, RES_HOTEL_DETAIL, RES_HOTEL_ORDER, RES_ORDER_INFO, RES_ORDER_INPUT } from './daolv-api'

// 轮播广告
export function adInfo (): Promise<RES_ADINFO> {
  return request('/saas/daolv/product/adInfo')
}

// 获取城市
export function daolvCity (params: {
  cityName: string, // 城市代码
  countryCode?: string // 国家代码
}): Promise<any> {
  return request(`/saas/daolv/product/city?${formatParam(params)}`, {
    method: 'POST'
  })
}

// // 获取国家
// export function country (): Promise<any> {
//   return request('/saas/daolv/product/country')
// }

// 酒店详情查询
export function getHotelDetail (params: REQ_HOTEL_DETAIL): Promise<RES_HOTEL_DETAIL> {
  return request(`/saas/daolv/product/hotelDetail?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 酒店列表查询
export function getHotelList (params: REQ_LIST): Promise<any> {
  return request(`/saas/daolv/product/hotelList?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 精品推荐城市
export function tuijianCity (): Promise<any> {
  return request('/saas/daolv/product/tuijianCity')
}

// 输入订单信息
export function orderInput (params: REQ_ORDER_INPUT): Promise<RES_ORDER_INPUT> {
  return request(`/saas/daolv/product/orderInput?${formatParam(params)}`, {
    method: 'POST'
  })
}

// 创建订单
export function orderCreate (data: REQ_HOTEL_ORDER): Promise<RES_HOTEL_ORDER> {
  return request('/saas/daolv/product/orderCreate', {
    method: 'POST',
    data: data
  })
}

// 支付订单
export function orderPay (orderId: string): Promise<RES_HOTEL_ORDER> {
  return request(`/saas/daolv/product/orderPay?orderId=${orderId}`)
}

// 查看订单信息
export function orderInfo (orderId: string): Promise<RES_ORDER_INFO> {
  return request(`/saas/daolv/product/orderInfo?orderId=${orderId}`)
}

// 获取下单要传的分销商
export function distributorUsrs (custName : string): Promise<any> {
  return request(`/saas/daolv/product/usrs?custName=${custName}`, {
    method: 'POST'
  })
}
